import { Button, DataTable } from "@nabble/ui";
import { useMemo, useState } from "react";
import type { Passkey } from "../../../../api/secondFactors";
import { AddPasskeyDialog } from "./AddPasskeyDialog";
import { passkeyColumns } from "./passkeyColumns";
import { RemovePasskeyDialog } from "./RemovePasskeyDialog";

/** Second factor → Passkeys: the registered ones, with adding and removing. */
export function PasskeysRow({ passkeys, onChanged }: { passkeys: Passkey[]; onChanged: () => void }): React.JSX.Element {
  const [addOpen, setAddOpen] = useState(false);
  const [removeTarget, setRemoveTarget] = useState<Passkey | null>(null);
  const columns = useMemo(() => passkeyColumns(setRemoveTarget), []);

  return (
    <>
      <div className="nb-setting-row is-stacked">
        <div className="nb-setting-head">
          <div>
            <div className="nb-setting-title">Passkeys</div>
            <p className="nb-setting-desc">Face ID, Touch ID, Windows Hello or a security key. Each one is linked to a device.</p>
          </div>
          <Button label="Add passkey" variant="secondary" size="sm" icon="plus" onClick={() => setAddOpen(true)} />
        </div>
        {passkeys.length > 0 ? (
          <DataTable<Passkey> minimal rowKey="id" rows={passkeys} columns={columns} ariaLabel="Passkeys" />
        ) : (
          <p className="nb-help">You don't have any passkeys registered.</p>
        )}
      </div>

      {addOpen ? (
        <AddPasskeyDialog
          onClose={() => setAddOpen(false)}
          onAdded={() => {
            setAddOpen(false);
            onChanged();
          }}
        />
      ) : null}

      <RemovePasskeyDialog
        target={removeTarget}
        onClose={() => setRemoveTarget(null)}
        onRemoved={() => {
          setRemoveTarget(null);
          onChanged();
        }}
      />
    </>
  );
}
